module.exports = __webpack_public_path__ + "static/media/logo-blue.d5ed730c.svg";